import React from "react";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import GenericButton from "components/Buttons/GenericButton";
import { Box, Typography } from "@material-ui/core";

const InactiveEmployeeConfirmationModal = ({ open, onCancel, onConfirm, employee, motive, loading }) => {
  return (
    <GenericDialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <Typography variant="h2" color="primary" style={{ fontSize: "1.6rem", marginBottom: "1.5rem" }}>
        Eliminar Trabalhador
      </Typography>

      <Box mb={2}>
        <Typography variant="body1" style={{ marginBottom: "1.5rem" }}>
          Tem a certeza que pretende eliminar o seguinte trabalhador do Mapa RENT?
        </Typography>
        <Typography variant="body1">
          <strong>Nome:</strong> {employee?.name}
        </Typography>
        <Typography variant="body1">
          <strong>NIF:</strong> {employee?.nif}
        </Typography>
        <Typography variant="body1">
          <strong>NISS:</strong> {employee?.ssn}
        </Typography>
        <Typography variant="body1">
          <strong>Motivo:</strong> {motive}
        </Typography>
      </Box>
      <Box
        mb={3}
        style={{
          backgroundColor: "#ffebee",
          color: "#c62828",
          padding: "16px",
          borderRadius: "4px",
          border: "1px solid #c62828",
          fontWeight: 500,
          fontSize: "1rem",
        }}
      >
        Atenção: Esta ação é <b>irreversível</b>. O trabalhador não poderá ser adicionado novamente ao Mapa RENT.
      </Box>
      <Box display="flex" justifyContent="flex-end" gridGap={12}>
        <GenericButton color="tertiary" onClick={onCancel}>
          Cancelar
        </GenericButton>
        <GenericButton color="primary" onClick={onConfirm} loading={loading}>
          Confirmar
        </GenericButton>
      </Box>
    </GenericDialog>
  );
};

export default InactiveEmployeeConfirmationModal;
